import { FC } from 'react';
import { Box, Button, Popover, Theme } from '@material-ui/core';
import PopupState, { bindPopover, bindTrigger } from 'material-ui-popup-state';
import { VideoIcon, VideoIcon2 } from 'svgs';
import { aboutCompanyDesktopVideo, aboutCompanyMobileVideo } from 'videos';
import { createStyles, makeStyles } from '@material-ui/styles';
import { useMediaUp } from 'hooks';

interface VideoPopupProps {
  reverse?: boolean;
  video?: any;
}

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    button: {
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    paddingVideo: {
      padding: theme.spacing(2, 2, 0),
    },
  });
});

const VideoPopup: FC<VideoPopupProps> = ({ reverse = false, video }) => {
  const classes = useStyles(reverse);
  const isSmallUp = useMediaUp('lg');
  return (
    <PopupState variant="popover" popupId="demo-popup-popover">
      {(popupState) => (
        <div>
          <Button {...bindTrigger(popupState)} className={classes.button}>
            {reverse ? <VideoIcon /> : <VideoIcon2 />}
          </Button>
          <Popover {...bindPopover(popupState)} anchorReference={'none'}>
            <Box className={classes.paddingVideo}>
              <video autoPlay controls width={isSmallUp ? 1062 : '100%'} controlsList="nodownload">
                <source src={video || aboutCompanyMobileVideo} type="video/mp4" media="all and (max-width: 480px)" />
                <source src={video || aboutCompanyDesktopVideo} type="video/mp4" />
              </video>
            </Box>
          </Popover>
        </div>
      )}
    </PopupState>
  );
};

export default VideoPopup;
